import { Provider } from '../types/provider'

export function needsOnboarding(provider: Provider | null | undefined): boolean {
  if (!provider) return false
  return !provider.metadata?.onboardingCompleted
}
